module.exports = __webpack_public_path__ + "img/GAME_COLORLOTUS.a7ed50c7.png";